import axiosClient from "./AxiosClient";

class OrderApi {
    addOne(importType, token, params) {
        let url = '/order/create-from-data?importType=' + importType + '&token=' + token;
        return axiosClient.post(url, params);
    }
    uploadDocument(importType, token,params,formData) {
        let url = '/order/upload-document?importType=' + importType + '&token=' + token;
        return axiosClient.post(url, formData,{params});
    }
}

export default (new OrderApi());
